<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Создание заявки</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form @submit.prevent="createOrder">
                <v-text-field
                  label="Фамилия И.О."
                  v-model="order.ClientFIO"
                  prepend-icon="mdi-account"
                  type="text"
                />
                <v-text-field
                  label="Телефон"
                  prepend-icon="mdi-card-account-phone"
                  v-model="order.ClientPhone"
                  type="text"
                />
                <v-text-field
                label="Дата"
                type="date"
                v-model="order.Date"
                prepend-icon="mdi-calendar"
                />
                <v-textarea
                prepend-icon="mdi-text"
                label="Комментарий"
                type="text"
                v-model="order.Comment"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-row align-center justify="center">
                <v-btn color="success" type="submit" align-center justify-center v-on:click="createOrder">Отправить</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>

import OrderService from '../api-services/order.service'

export default {
    data(){
        return{
            order: {}
        };
    },
    components:{
      OrderService
    },
    methods:{
        async createOrder(){
            OrderService.create(this.order)
            console.log(this.order)
            this.$router.push("/thanks")
        }
    }
}
</script>